import type { DiffableArray } from './types';

interface CommonPrefixAndSuffix {
    prefixLength: number;
    suffixLength: number;
}

/**
 * Find equal edges so callers can exclude them from a more expensive comparison.
 */
export function findCommonPrefixAndSuffix<BeforeValue, AfterValue>(
    before: DiffableArray<BeforeValue>,
    after: DiffableArray<AfterValue>,
    areEquals: (a: BeforeValue, b: AfterValue) => boolean
): CommonPrefixAndSuffix {
    let prefixLength = 0;
    const shorterLength = Math.min(before.length, after.length);
    while (prefixLength < shorterLength) {
        const beforeValue = before.at(prefixLength);
        const afterValue = after.at(prefixLength);
        if (
            beforeValue === undefined ||
            afterValue === undefined ||
            !areEquals(beforeValue, afterValue)
        ) {
            break;
        }
        prefixLength += 1;
    }

    let suffixLength = 0;
    while (suffixLength < shorterLength - prefixLength) {
        const beforeValue = before.at(before.length - suffixLength - 1);
        const afterValue = after.at(after.length - suffixLength - 1);
        if (
            beforeValue === undefined ||
            afterValue === undefined ||
            !areEquals(beforeValue, afterValue)
        ) {
            break;
        }
        suffixLength += 1;
    }

    return { prefixLength, suffixLength };
}
